import React from 'react';

import Stepper from './stepper'
export default({data,toggleSubmitLoader})=>{
  return(
    <>

<Stepper {...data} toggleSubmitLoader={toggleSubmitLoader}/>
    </>
  ) 
}
